import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/**
 * 首席科学家预估意见表
 */
export default new Router({
    mode: 'history',

    routes: [{
            path: '/applyPdf',
            component: () => import('@/pages/options/ApplyPdf.vue'),
        },
        {
            path: '/CsApplyPdf',
            component: () => import('@/pages/options/CsApplyPdf.vue'),
        },
        {
            path: '*',
            redirect: '/index'
        },
        {
            path: '/index',
            name: 'index',
            component: () => import('@/main.vue'),
            redirect: "/home",
            children: [{
                    path: '/home',
                    name: 'home',
                    component: () => import('../pages/home/index.vue')
                }, {
                    path: '/scientificOrientation',
                    name: 'scientificOrientation',
                    component: () => import('../pages/scientificOrientation/index.vue')
                },
                {
                    path: '/news',
                    name: 'news',
                    component: () => import('../pages/news/index.vue')
                },
                {
                    path: '/detail',
                    name: 'newsDetail',
                    component: () => import('../pages/news/detail.vue')
                },
                {
                    path: '/VoyageDetail',
                    name: 'voyageDetail',
                    component: () => import('../pages/voyage/detail.vue')
                },
                {
                    path: '/svpChiefTraining',
                    name: 'svpChiefTraining',
                    component: () => import('../pages/svpChiefTraining/index.vue')
                },
                {
                    path: '/options',
                    name: 'options',
                    component: () => import('../pages/options/index.vue')
                },
                {
                    path: '/options_detail',
                    name: 'options_detail',
                    component: () => import('../pages/options/detail.vue')
                },
                {
                    path: '/diary',
                    name: 'diary',
                    component: () => import('../pages/diary/index.vue')
                },
                {
                    path: '/diary_list',
                    name: 'diary_list',
                    component: () => import('../pages/diary/diary_list.vue')
                },
                {
                    path: '/diary_detail',
                    name: 'diary_detail',
                    component: () => import('../pages/diary/diary_detail.vue')
                },
                {
                    path: '/timeline',
                    name: 'timeline',
                    component: () => import('../pages/timeline/index.vue')
                },
                {
                    path: '/ChiefScientistExplain',
                    name: 'ChiefScientistExplain',
                    component: () => import('../pages/options/ChiefScientistExplain.vue')
                },
                {
                    path: '/ChiefScientistForm',
                    name: 'ChiefScientistForm',
                    component: () => import('../pages/options/ChiefScientistForm.vue')
                },
                {
                    path: '/ChiefScientistOpinion',
                    name: 'ChiefScientistOpinion',
                    component: () => import('../pages/options/ChiefScientistOpinion.vue')
                },
                {
                    path: '/ChiefScientistOpinionForm',
                    name: 'ChiefScientistOpinionForm',
                    component: () => import('../pages/options/ChiefScientistOpinionForm.vue')
                },
                {
                    path: '/voyage',
                    name: 'voyage',
                    component: () => import('../pages/voyage/index.vue')
                },
                {
                    path: '/about',
                    name: 'about',
                    component: () => import('../pages/about/index.vue')
                },
                {
                    path: '/register',
                    name: 'register',
                    component: () => import('../pages/login/register.vue')
                },
                {
                    path: '/login',
                    name: 'login',
                    component: () => import('../pages/login/login.vue')
                },
                {
                    path: '/findPwd',
                    name: 'findPwd',
                    component: () => import('../pages/login/findPwd.vue')
                },
                {
                    path: '/setting',
                    name: 'setting',
                    component: () => import('../pages/login/setting.vue')
                },
                {
                    path: '/importantPrjCS',
                    name: 'importantPrjCS',
                    component: () => import('../pages/options/ImportantPrjCS.vue')
                },
            ]
        }
    ]
})
